<span class="mat-headline-6">
    Total CargoSprint SprintPay available balance: {{ (creditAmount > 0 ? creditAmount : 0) | currency }}
</span>
@if (showMessage && !externalMessage) {
    <div class="mat-subtitle-2 message mt-2">
        It seems you don't have enough credit for your next transaction, please contact
        <a [href]="'mailto:collections@cargosprint.com' | sanitize: 'url'">collections&#64;cargosprint.com</a>
        to get help.
    </div>
}
<ng-content />
